import { Contact } from "@/features/Contact";

export default function ContactPage() {
  return <Contact />;
}
